import { Component } from '@angular/core';
import 'moment/locale/id';
import { BaseListBComponent } from '../../../libraries/base/list/base-list.bcomponent';
import { DashboardDealerRestService } from './dashboard-dealer-rest.service';
import { map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'dashboard-dealer-credit-note',
  templateUrl: 'dashboard-dealer-credit-note.component.html'
})
export class DashboardDealerCreditNoteComponent extends BaseListBComponent<{
  mainDealerName: string;
  region: string;
  totalCreditNote: number;
}> {
  tableColumns = [
    {
      i18nLabel: 'ui.creditNote.detail.entity.month',
      field: 'date',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.category',
      field: 'category',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.quantity',
      field: 'quantity',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.revenue',
      field: 'revenue',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.deductedAmount',
      field: 'deductedAmount',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.remainingCredit',
      field: 'remainingCredit',
      sort: true
    },
    {
      i18nLabel: 'ui.creditNote.detail.entity.note',
      field: 'note',
      sort: true
    }
  ];
  tableColumnsShow: boolean = false;
  tableColumnsToggle = this._gridTableToggle.mapToggleOptionsFromColumns(this.tableColumns);

  constructor(private api: DashboardDealerRestService) {
    super();
    this.componentId = 'DashboardDealerCreditNoteComponent';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'loadData',
      handle: event => {
        const qOption = event.data.qOption;
        qOption['limit'] = qOption['take'];
        delete qOption['take'];
        delete qOption['skip'];
        const qParams = Object.assign({}, event.data.qParams, qOption, this.qParams);
        return this.api.getCreditNoteHistories(qParams).pipe(
          switchMap(doc => {
            const dataFormatted = doc?.data?.map((d: any) => ({
              ...d,
              date: moment(d?.date).format('DD MMMM YYYY'),
              revenue: this.formatRupiah(d?.revenue),
              category: d.category.replaceAll('_', ' '),
              deductedAmount: this.formatRupiah(d?.deductedAmount),
              remainingCredit: this.formatRupiah(d?.remainingCredit)
            }));

            doc.data = dataFormatted;
            return of(doc);
          })
        );
      },
      wrapRetryableTask: true,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () =>
        this.page.compHookService?.callMultipleHooks(['DashboardDealerCreditNoteComponent:workflowLoadData'])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }
}
